const links = {
  gitHub:'https://github.com/ltlkong',
  linkedIn:'https://www.linkedin.com/in/tielin-li-a3335820b/',
  email:'mailto:tielinli@yahoo.com',
  instagram:'https://www.instagram.com/tielin_li/',
  leetcode:'https://leetcode.com/ltlkong/'
}

export default links;